<template>
  <el-dialog
      title="Поиск и добавление БАДов"
      :visible="visible"
      :before-close="close"
      width="80%"
      @open="onOpen"
      :close-on-press-escape="false"
  >
    <div v-loading="loading">

      <div class="search-tab">
        <div class="search-tab__title">Поиск :</div>
        <el-input class="search-tab__input"
                  v-model="search"
                  placeholder="Введите название БАДа..."
                  suffix-icon="el-icon-search"
        />
      </div>

      <supplement-list :products="products" @save="save"/>

      <footer-buttons mt>
        <el-button type="primary"
                   style="width: 50%; margin: 20px auto 0 auto;"
                   @click="saveSupplement"
                   :disabled="loading">Добавить выбранное
        </el-button>
      </footer-buttons>
    </div>

  </el-dialog>
</template>

<script>
import FooterButtons from "@/components/dialog/FooterButtons"
import {mapGetters} from "vuex";
import SupplementList from "@/components/visit/conclusion/SupplementList.vue"
import _ from 'lodash'


export default {
  name: "AddSupplement",
  data() {
    return {
      search: '',
      loading: false,
      dataForSave: [],
      products: []
    }
  },
  props: {
    visible: {
      required: true,
    }
  },
  watch: {
    search() {
      this.debouncedGetAnswer()
    }
  },
  computed: {
    ...mapGetters("visit", {
          conclusion: "conclusion"
        }
    ),
  },
  created() {
    this.debouncedGetAnswer = _.debounce(this.getProducts, 500)
  },
  components: {
    FooterButtons,
    SupplementList
  },
  methods: {
    saveSupplement() {
      this.$emit('addNewSupplement', this.dataForSave)
      this.close()
    },
    getProducts() {

      this.loading = true
      let payLoad = {
        params: {
          search: this.search
        }
      }

      this.$api.marketProducts.getList(this.conclusion.id, payLoad).then((require) => {
        this.products = require.data
      }).catch((response) => {
        this.$notify.error({
          title: "Ошибка загрузки списка 😕",
          message: response.response.data.message,
        })
      }).finally(() => {
        this.loading = false
      })

    },
    onOpen() {
      this.search = ''
      this.products = []

      this.getProducts()
    },
    close() {
      this.$emit('close')
    },

    save() {
      this.dataForSave = this.products.filter(item => item.selected === true)

    },


  }
};
</script>

<style scoped lang="scss">

.search-tab {
  display: flex;
  align-items: center;

  gap: 6px;

  &__title {
    font-size: 13px;
    line-height: 16px;
    color: #8E8E93;

  }

  &__input {
    width: 245px;

  }
}

</style>

